
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-videos",
      function () {
        return require("private-next-pages/ai-videos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-videos"])
      });
    }
  